import * as React from 'react';
import { useState, useEffect } from 'react';
import './Info.scss';
import { colors, Text } from 'react-elemental';
import success from '../../commons/assets/reserva_exitosa_yellow.svg';
import { 
  getBookingDataFromStorage, 
  clearBookingDataFromStorage,
  downloadICSFile 
} from '../../utils/calendar';

// Icono de calendario SVG inline
const CalendarIcon = () => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    style={{ marginRight: '8px', verticalAlign: 'middle' }}
  >
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);

/**
 * Formatea una fecha para mostrar al usuario
 * @param {Date} date - Fecha a formatear
 * @returns {string} - Fecha formateada
 */
function formatBookingDate(date) {
  if (!date) return '';
  
  const options = { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  
  return date.toLocaleDateString('es-CL', options);
}

function Info(props) {
  const [bookingData, setBookingData] = useState(null);
  const [downloadSuccess, setDownloadSuccess] = useState(false);

  useEffect(() => {
    // Recuperar datos de la reserva desde localStorage
    const data = getBookingDataFromStorage();
    if (data) {
      setBookingData(data);
    }
  }, []);

  const handleAddToCalendar = () => {
    if (bookingData) {
      downloadICSFile(bookingData);
      setDownloadSuccess(true);
      
      // Resetear el mensaje de éxito después de 3 segundos
      setTimeout(() => {
        setDownloadSuccess(false);
      }, 3000);
    }
  };

  const handleNewBooking = () => {
    // Limpiar datos al iniciar nueva reserva
    clearBookingDataFromStorage();
    props.history.push('/app');
  };

  return (
    <div className="mb-5">
      <div className="text-center mt-5">
        <img
          alt="Success"
          src={ success }
          className="mb-2"
          width="100px"
          height="auto"
        />
        <div
          className="col-md-5 col-sm-12 col-xs-12 text-danger ml-auto mr-auto mb-4"
        >
          <h4 className="custom-title black mt-3">
            ¡Tu reserva se ha realizado
            con éxito!
          </h4>
        </div>

        {/* Mostrar detalles de la reserva si están disponibles */}
        {bookingData && (
          <div className="booking-details col-md-6 col-sm-12 col-xs-12 ml-auto mr-auto mb-4">
            <div className="booking-info-card">
              <h5 className="booking-info-title">Detalles de tu reserva</h5>
              
              <div className="booking-info-row">
                <span className="booking-info-label">Fecha y hora:</span>
                <span className="booking-info-value">
                  {formatBookingDate(bookingData.date)}
                </span>
              </div>
              
              {bookingData.station && (
                <div className="booking-info-row">
                  <span className="booking-info-label">Estación:</span>
                  <span className="booking-info-value">
                    {bookingData.station.name}
                  </span>
                </div>
              )}
              
              {bookingData.station?.address && (
                <div className="booking-info-row">
                  <span className="booking-info-label">Dirección:</span>
                  <span className="booking-info-value">
                    {bookingData.station.address}
                  </span>
                </div>
              )}
              
              {bookingData.vehicle && (
                <div className="booking-info-row">
                  <span className="booking-info-label">Vehículo:</span>
                  <span className="booking-info-value">
                    {bookingData.vehicle.brand} {bookingData.vehicle.model} - {bookingData.vehicle.patent}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}

        <Text
          size="iota"
          className="text-center col-md-6 col-sm-12 col-xs-12 mb-0 ml-auto mr-auto"
          color={ colors.gray55 }
          bold
        >
          Se ha enviado un correo con la información de la reserva.
          <br />
          Si aún no recibes el mensaje, por favor revisa tus correos no
          deseados.
          <br />
          Recuerda, te esperamos hasta 15 minutos después de la hora agendada.
          <br />
        </Text>

        {/* Botón Agregar al Calendario */}
        {bookingData && (
          <div className="calendar-button-container mt-4 mb-3">
            <button 
              className="btn-calendar"
              onClick={handleAddToCalendar}
              type="button"
            >
              <CalendarIcon />
              Agregar al Calendario
            </button>
            {downloadSuccess && (
              <div className="calendar-success-message">
                ¡Archivo descargado! Ábrelo para agregar el evento a tu calendario.
              </div>
            )}
          </div>
        )}

        <Text
          size="iota"
          className="text-center w-100 mb-5 mt-3"
          color={ colors.gray50 }
          bold
        >
          <strong>¡Nos vemos!</strong>
          <br/><br/>
          Cualquier duda nos pueden escribir al mail cambiaconhelix@enex.cl
        </Text>

        <span
          className="mt-4 btn-back"
          onClick={handleNewBooking}
        >
          Agendar otro vehículo
        </span>
      </div>

    </div>
  );
}

export default Info;
